import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ThemeProvider } from 'styled-components';
import { ConfigProvider, Empty } from 'antd';
import store from './redux/store';
import theme from './configs/theme';
import Routes from './routes';
import './configs/language';
import * as serviceWorker from './serviceWorker';
import AppWrapper, { GlobalStyle } from './appStyle';
import { initFirebase } from './api/firebase';

initFirebase();
ReactDOM.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <AppWrapper>
        <GlobalStyle />
        <ConfigProvider renderEmpty={() => <Empty />}>
          <Routes />
          <div
            className="fb-customerchat"
            attribution="setup_tool"
            page_id="236598804811289"
            theme_color="#F47D25"
          />
        </ConfigProvider>
      </AppWrapper>
    </ThemeProvider>
  </Provider>,
  document.getElementById('root'),
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
